import { render, staticRenderFns } from "./org-members.vue?vue&type=template&id=59f96d23&scoped=true&"
import script from "./org-members.vue?vue&type=script&lang=js&"
export * from "./org-members.vue?vue&type=script&lang=js&"
import style0 from "./org-members.vue?vue&type=style&index=0&id=59f96d23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f96d23",
  null
  
)

export default component.exports